//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  defineComponent, ref, computed, onMounted, onBeforeUnmount,
  toRefs,
} from '@vue/composition-api';
import { FocusTrap } from 'focus-trap-vue';
import { FCInput, FCButton, FCSelect } from '@fc/angie-ui';
import FCImage from '~/components/FCImage.vue';
import { EMAIL_VALIDATOR } from '~/constants/regex';
import WrapGloveSize from '~/components/v2/pdps/WrapGloveSize.vue';

export default defineComponent({
  name: 'ValentinesModal',
  components: {
    FocusTrap,
    FCInput,
    FCButton,
    FCImage,
    FCSelect,
    WrapGloveSize,
  },
  props: {
    id: { type: String, default: '' },
    embed: { type: Boolean, default: false },
    partnerWorkoutPackOptions: {
      type: Array,
      required: true,
    },
    partnerWorkoutPack: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const modalActive = ref(true);
    const email = ref('');
    const emailError = ref(false);
    const emailErrorMsg = ref('');
    const loading = ref(false);
    const partnerWorkoutPackError = ref(false);
    const errorMessage = ref('Please select a size');

    const buttonTheme = computed(() => (loading.value ? 'button-disabled' : 'button-primary'));

    const app = useNuxtApp();

    const { partnerWorkoutPack: partnerWorkoutPackLocal } = toRefs(props);

    const validateEmail = async () => {
      emailErrorMsg.value = '';
      if (email.value === '') {
        return;
      }
      emailError.value = !EMAIL_VALIDATOR.test(String(email.value).toLowerCase());
      if (emailError.value) {
        emailErrorMsg.value = 'Please enter a valid email address.';
        return;
      }
      const res = await app.$api_client.validateEmail(email.value.toLowerCase());
      if (!res.emailValid) {
        emailErrorMsg.value = 'Invalid Email. Please check for errors or try with another email.';
      }
    };

    const resetError = () => {
      emailError.value = false;
      emailErrorMsg.value = '';
      partnerWorkoutPackError.value = false;
    };

    const submitEmail = async () => {
      resetError();
      loading.value = true;

      try {
        if (!props.partnerWorkoutPack.value) {
          partnerWorkoutPackError.value = true;
          loading.value = false;
          return;
        }

        if (email.value) {
          await validateEmail();
          if (emailError.value) {
            loading.value = false;
            return;
          }

          app.$ecommAnalytics.identifyByEmail(email.value);
          app.$analytics.emailIdentified(email.value);
          app.$bugsnag.setUser({ email: email.value });
          app.$analytics.trackEvent('EmailCapture', {
            email: email.value,
            source: 'Valentines2025Promo',
          });
          app.$store.commit('Valentines2025Promo', true);

          await app.$store.dispatch('identifyByEmail', email.value);
        }

        loading.value = false;
        emit('close');
      } catch (error) {
        emailError.value = true;
        emailErrorMsg.value = error.message;
        loading.value = false;
      }
    };

    const closeModal = () => {
      emit('close');
      modalActive.value = false;
    };

    onMounted(() => {
      app.$ecommAnalytics.campaign({ name: 'Valentines2025Promo', action: 'viewed', type: 'modal' });
    });

    onBeforeUnmount(() => {
      modalActive.value = false;
    });

    return {
      modalActive,
      email,
      emailError,
      emailErrorMsg,
      loading,
      partnerWorkoutPackError,
      errorMessage,
      buttonTheme,
      validateEmail,
      resetError,
      submitEmail,
      closeModal,
      partnerWorkoutPackLocal,
    };
  },
});
